module.exports = __webpack_public_path__ + "img/9788997132133.8704e1a9.jpg";